// @flow

import compose from './compose'
export default compose
